import { BagCarryOnCheckIcon } from './BagCarryOnCheckIcon';

/**
 * author: Google
 * id 57DD596E-AFB6-46D2-8415-2DED40839B11
 * name bag-carry-on-check
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bag-carry-on-check.svg
 * tags
 * - Transportation + Flying 
 */
export const CarryOnBagTickIcon = BagCarryOnCheckIcon;
export default CarryOnBagTickIcon